import { render, staticRenderFns } from "./PromoCodeBanner.vue?vue&type=template&id=16b13efe&scoped=true"
import script from "./PromoCodeBanner.vue?vue&type=script&lang=js"
export * from "./PromoCodeBanner.vue?vue&type=script&lang=js"
import style0 from "./PromoCodeBanner.vue?vue&type=style&index=0&id=16b13efe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b13efe",
  null
  
)

export default component.exports